import type { SplitBlock as SplitBlockType } from "@/types";
import { renderMarkdown } from "@/lib/markdown";

export function SplitBlock({ block }: { block: SplitBlockType }) {
  const { heading, body_md, asset_url, alt, image_side = "left" } = block.props;
  const html = renderMarkdown(body_md);
  return (
    <section className={`block block--split block--split--${image_side}`}>
      {asset_url ? (
        <div className="block--split__media">
          <img src={asset_url} alt={alt ?? ""} loading="lazy" />
        </div>
      ) : null}
      <div className="block--split__body">
        {heading ? <h2>{heading}</h2> : null}
        <div className="prose" dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </section>
  );
}
